// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { Translate } from '@plesk/ui-library';
import {
    ISwitchWithConfirmationProps,
    SwitchWithConfirmation,
} from 'common/components/SwitchWithConfirmation';

export interface IVZTUNTAPProps extends Omit<
    ISwitchWithConfirmationProps,
    'confirmOnDisable' | 'confirmOnEnable' | 'checked' | 'value' | 'label'
> {
    value: boolean;
    label?: React.ReactNode | string;
}

const VZTUNTAPControl: React.FC<IVZTUNTAPProps> = ({
    value,
    label,
    ...props
}) => {
    const confirmation = {
        enabled: true,
        translations: {
            title: <Translate content="servers.controls.vzTUNTAP.confirmation.title" />,
            text: <Translate content="servers.controls.vzTUNTAP.confirmation.text" />,
            button: <Translate content="servers.controls.vzTUNTAP.confirmation.button" />,
        },
    };

    return (
        <SwitchWithConfirmation
            {...props}
            checked={value}
            confirmOnDisable={confirmation}
            confirmOnEnable={confirmation}
        >
            {label}
        </SwitchWithConfirmation>
    );
};

export default VZTUNTAPControl;